import Vue from 'vue'

/**
 * 乙方名称列表
 * @param data
 * @returns {*}
 */
export function getCompanyList(data) {
  return Vue.axios({
    url: '/api/company/list',
    method: 'post',
    data: {...data}
  })
}

/**
 * 新增乙方名称
 * @param data
 * @returns {*}
 */
export function createCompanyData(data) {
  return Vue.axios({
    url: '/api/company/create',
    method: 'post',
    data: {...data}
  })
}

/**
 * 修改乙方名称
 * @param data
 * @returns {*}
 */
export function updateCompanyData(data) {
  return Vue.axios({
    url: '/api/company/update',
    method: 'post',
    data: {...data}
  })
}

/**
 * 删除乙方名称
 * @param data
 * @returns {*}
 */
export function deleteCompanyData(data) {
  return Vue.axios({
    url: '/api/company/delete',
    method: 'post',
    data: {...data}
  })
}


export function getCompanyOtList(params) {
  return Vue.axios({
    url: '/api/company_ot/list',
    method: 'get',
    params
  })
}

export function getCompanyOtOptions(params) {
  return Vue.axios({
    url: '/api/company_ot/options',
    method: 'get',
    params
  })
}

export function saveCompanyOt(data) {
  return Vue.axios({
    url: '/api/company_ot/save',
    method: 'post',
    data
  })
}



